module.exports = __webpack_public_path__ + "img/18.f729f175.jpg";